import { SpeechBubble } from "./SpeechBubble";

type ThinkingIndicatorProps = {
  text: string;
};

export const ThinkingIndicator: React.FC<ThinkingIndicatorProps> = ({
  text,
}) => {
  // The shimmer loops for as long as the status is shown — during a voice call
  // that is the whole conversation, which WCAG 2.3.3 asks us not to do
  // (`motion-safe:`), and which must not cost a repaint per frame: a CSS
  // transform animation stays on the compositor, a Motion `backgroundPosition`
  // keyframe ran on the JS frameloop and repainted the backdrop-blurred panel
  // 120 times a second.
  return (
    <SpeechBubble
      sender="assistant"
      className="flex items-center gap-2 w-fit"
      role="status"
      aria-live="polite"
    >
      <span className="justify-start text-black">{text}</span>
      <div className="w-8 h-3 rounded-full overflow-hidden" aria-hidden="true">
        <div
          className="h-full w-[800%] motion-safe:animate-shimmer"
          style={{
            background:
              "linear-gradient(90deg, var(--color-purple-900) 0%, var(--color-purple-900) 15%, var(--color-purple-500) 40%, var(--color-purple-300) 50%, var(--color-purple-500) 60%, var(--color-purple-900) 85%, var(--color-purple-900) 100%)",
            // Two gradient tiles; one tile per loop keeps the seam invisible.
            backgroundSize: "50% 100%",
          }}
        />
      </div>
    </SpeechBubble>
  );
};

export default ThinkingIndicator;
